const webAddress = process.env.REACT_APP_WEB_ADDRESS || 'https://staging.gradarius.com';
const accessKey = process.env.REACT_APP_ACCESS_KEY || 'lu1vma2njutjoisanp8hkdqp4p';
const problemIds = process.env.REACT_APP_PROBLEMS ? JSON.parse(process.env.REACT_APP_PROBLEMS) : [11368, 11364, 11366, 11362];
export const environment = { webAddress, accessKey, problemIds };
